import styled from 'styled-components';

import Button from '@components/Button/next';

export const DatelessWarningWrapper = styled.div`
  width: 220px;
  margin-bottom: 8px;
  white-space: normal;
  border-radius: 8px;
  overflow: hidden;
  text-align: right;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 17px;
    width: 100%;
    text-align: left;
  }
`;

export const StyledButtonDateless = styled(Button)<{ isSelected: boolean }>`
  width: 100%;
  height: 40px;
  font-weight: bold;
  font-size: 14px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.NL0};
  color: ${({ theme }) => theme.palette.R600};
  border: 1px solid ${({ theme }) => theme.palette.R600} !important;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 195px;
  }
`;
